import React, { useState, useEffect } from "react";
import useJWT from "../../hooks/useJWT";
import useAddress from "../../hooks/useAddress";
import Swal from "sweetalert2";

const accountAddress = [
  {
    id: "1",
    name: "Account Name 1",
    phone: "(012) 456-789-1011",
    address: "123 Orchard Road, #12-34 Orchard Plaza, Singapore 238888",
    isPrimary: true,
    isSelected: true,
  },
  {
    id: "2",
    name: "Account Name 2",
    phone: "(012) 456-789-1011",
    address: "123 Orchard Road, #12-34 Orchard Plaza, Singapore 238888",
    isPrimary: false,
    isSelected: false,
  },
  {
    id: "3",
    name: "Account Name 3",
    phone: "(012) 456-789-1011",
    address: "123 Orchard Road, #12-34 Orchard Plaza, Singapore 238888",
    isPrimary: false,
    isSelected: false,
  },
];

const SelectAddress = ({ addressEnumChange, onEdit }) => {
  const { user } = useJWT();

  const {
    fetchAddress,
    removeAddress,
    setPrimary,
    data,
    removeStatus,
    setPrimaryStatus,
    error,
    resetStatus,
  } = useAddress();

  const [selectedAddress, setSelectedAddress] = useState(
    accountAddress.find((address) => address.isSelected).id
  );
  const [addressList, setAddressList] = useState(accountAddress);

  useEffect(() => {
    if (user) {
      fetchAddress(user.id);
    }
  }, [user]);

  useEffect(() => {
    if (setPrimaryStatus === "done") {
      Swal.fire("Changed!", "Primary address changed", "success");
      fetchAddress(user.id);
      resetStatus();
    } else if (setPrimaryStatus === "error") {
      Swal.fire(
        "Error!",
        error.message || "Something went wrong while changing the primary address.",
        "error"
      );
      resetStatus();
    }
  }, [setPrimaryStatus, error]);

  useEffect(() => {
    if (removeStatus === "done") {
      Swal.fire("Deleted!", "Your address has been deleted.", "success");
      fetchAddress(user.id);
      resetStatus();
    } else if (removeStatus === "error") {
      Swal.fire(
        "Error!",
        error.message || "Something went wrong while deleting the address.",
        "error"
      );
      resetStatus();
    }
  }, [removeStatus, error]);

  const handlePaymentChange = (event) => {
    setSelectedAddress(event.target.id);
  };

  const handleSetPrimary = (addressId) => {
    setPrimary(addressId);
  };

  const onDeleteClicked = async (addressId) => {
    // swall
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      await removeAddress(addressId);
    }
  };

  return (
    <section className="checkout p-10">
      <div className="container container-lg">
        <h6 className="text-xl mb-24">Address</h6>
        <button
          onClick={() => {
            addressEnumChange(5);
          }}
          className="btn border border-main-one-600 text-main-one-600 mb-24"
        >
          <i class="ph ph-plus-circle"></i> Add New Address
        </button>
        <div className="mb-40">
          {data?.length === 0 && (
            <div className="cart-action d-flex flex-wrap justify-content-center align-items-center mt-40">
              <img src="/assets/images/no-data.svg" width={"60%"} alt="" />
            </div>
          )}

          {data?.map((address) => (
            <div
              className="border border-gray-100 d-block d-lg-flex flex-between align-items-center rounded-8 px-30 py-20 mb-10 w-100"
              key={address.id}
            >
              <div>
                <div className="d-block d-lg-flex w-100 align-items-center justify-content-between">
                  <div className="mb-16" style={{ cursor: "pointer" }}>
                    <div className="d-flex align-items-center gap-16">
                      <h6 className="text-xl fw-bold mb-8">{address.name}</h6>
                      <span className="text-sm text-gray-600 mb-8">
                        {address.phone}
                      </span>
                    </div>
                    <div className="">
                      <span className="text-sm text-gray-600 fw-normal">
                        {address.province ? `${address.province}, ` : ""}
                        {address.streetName ? `${address.streetName}, ` : ""}
                        {address.otherDetail ? `${address.otherDetail}` : ""}
                      </span>
                    </div>
                    {address.isPrimary && (
                      <div
                        className="border mt-10 border-main-one-600 rounded-8 px-20 py-5 mb-10"
                        style={{ width: "fit-content" }}
                      >
                        <span className="text-main-one-600">Primary</span>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="d-flex align-items-center gap-16">
                <button
                  className="text-main-one-600 text-decoration-underline"
                  onClick={() => {
                    onEdit(address.id);
                  }}
                >
                  Edit
                </button>
                <button
                  className="text-main-one-600 text-decoration-underline"
                  onClick={() => onDeleteClicked(address.id)}
                >
                  Delete
                </button>
                {!address.isPrimary && (
                  <span
                    className="text-main-one-600 text-decoration-underline"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      handleSetPrimary(address.id);
                    }}
                  >
                    Set Primary
                  </span>
                )}
              </div>
            </div>
          ))}
        </div>
        {/* <div className='d-flex w-100 justify-content-center'>
                    <button onClick={() => { addressEnumChange(2) }} className='btn btn-main-one'><i class="ph ph-plus-circle"></i> Add New Address</button>
                </div> */}
      </div>
    </section>
  );
};

export default SelectAddress;
